import { render, staticRenderFns } from "./frontServiciosContainer.vue?vue&type=template&id=572f6d1e&scoped=true&"
import script from "./frontServiciosContainer.vue?vue&type=script&lang=js&"
export * from "./frontServiciosContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572f6d1e",
  null
  
)

export default component.exports